import React from 'react';
import PropTypes from 'prop-types';

import Button from 'components/Button';
import Modal from 'components/Modal';
import ModalButtons from 'components/ModalButtons';

export default class ConfirmModal extends React.Component {
    static propTypes = {
        confirmOnClick: PropTypes.func.isRequired,
        confirmText: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.object
        ]).isRequired,
        content: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.object
        ]),
        declineOnClick: PropTypes.func.isRequired,
        declineText: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.object
        ]),
        show: PropTypes.bool.isRequired,
        title: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.object
        ])
    };

    render() {
        let showDeclineButton = this.props.declineOnClick != null && this.props.declineText != null;

        return (
            <Modal className="a-modal--confirm-modal"
                   closeModal={this.props.declineOnClick.bind(this)}
                   contentLabel="Please confirm in this modal"
                   show={this.props.show}
                   title={this.props.title}>

                {this.props.content}

                <ModalButtons buttonCount={showDeclineButton === true ? 2 : 1}>
                    <Button onClick={this.props.confirmOnClick.bind(this)}
                            type="button">
                        {this.props.confirmText}
                    </Button>

                    {showDeclineButton === true ? (
                        <Button className="a-button--grey"
                                onClick={this.props.declineOnClick.bind(this)}
                                type="button">
                            {this.props.declineText}
                        </Button>
                    ) : null}
                </ModalButtons>
            </Modal>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/Modal/ConfirmModal/index.js